import { getCategory } from '../../common/selectors/categories-selectors';

export const getLastFeaturedPost = (state) => state.lastFeaturedPost;

export const getLastFeaturedPostCategory = (state) =>
  getLastFeaturedPost(state) && getCategory(state, getLastFeaturedPost(state).categoryIds[0]);
